import { Button } from "../ui/button.tsx";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion.tsx";
import { TokenPairIcon } from "../ui/token-pairIcon.tsx";
import { useNavigate } from "react-router";
import usePairToken from "../../hooks/usePairToken";
import userPairInfo from "../../hooks/usePairInfo.js";
export default function AccordionModal({ tokenAAddress, tokenBAddress, pairAddress }) {
  const {data}  = usePairToken({tokenAAddress, tokenBAddress, pairAddress })
  const tokenA = data?.tokenA;
  const tokenB = data?.tokenB;
  const navigate = useNavigate();
  const { data: pairInfo } = userPairInfo(tokenA, tokenB, pairAddress)

  return (tokenA && tokenB && pairInfo &&
    <div className="p-4 rounded-lg bg-[#2C2F33] mb-2" >
      <Accordion type="single" collapsible >
        <AccordionItem value="item-1">
          <AccordionTrigger className="[&>svg]:text-[#F59E00]">
            <div className="flex items-center">
              <TokenPairIcon tokens={[tokenA, tokenB]} />
              <div className="text-md font-regular ml-[10px]">
                {tokenA.symbol}/{tokenB.symbol}
              </div>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <>
              <div className="space-y-[16px]">
                <div className="text-xs font-regular flex justify-between">
                  <span>您的流动池代币总额(LP):</span>
                  <span>{pairInfo.userBalance}</span>
                </div>
                <div className="text-xs font-regular flex justify-between">
                  <span>流动池汇集 {tokenA.symbol}:</span>
                  <span>{pairInfo.tokenABalance}</span>
                </div>
                <div className="text-xs font-regular flex justify-between">
                  <span>流动池汇集 {tokenB.symbol}:</span>
                  <span>{pairInfo.tokenBBalance}</span>
                </div>
                <div className="text-xs font-regular flex justify-between">
                  <span>您的流动池份额:</span>
                  <span>{pairInfo.percent}</span>
                </div>
              </div>
              <div className="flex items-center gap-x-[8px] mt-[25px]">
                <Button className="text-xs font-regular bg-[#F6A702] hover:bg-[#F6A702]/80  flex-1">
                  添加
                </Button>
                <Button
                  className="text-xs font-regular bg-[#F6A702] hover:bg-[#F6A702]/80  flex-1"
                  onClick={() => {
                    const toURL="/trade/remove-pair/" + tokenA.address + "/" + tokenB.address+ "/" + pairAddress;
                    navigate(toURL);
                  }}
                >
                  去除
                </Button>
              </div>
            </>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>)
}